import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Dāvis @t3chgiraffe', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Without a doubt the best ursa in EU', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'hello! you\'ve reached',
  name: 'Dāvis',
  subtitle: '..IoT enthusiast and artist sometimes masquerading as an athlete..',
  cta: 'Read the docs',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.JPEG',
  paragraphOne: "Greetings! My name is Dāvis 🇱🇻",
  paragraphTwo: 'I hail from Latvia, but I have spent quite a bit of time in Estonia 🇪🇪 I hold two degrees from University of Tartu - a BSc in Bioengineering and Robotics & MSc in Robotics and Computer Engineering.',
  paragraphThree: 'For some time biology and the code of life was my primary interest. However, the Robotics specialisation made me realise that computers are more predictable than ATGC, so my passion since has been building software!',
  paragraphFour: 'Besides coding my passions also include running marathons, skiing, painting, and piano 🎹',
  paragraphFive: 'Curiosity drives me - I\'m a generalist who picks up things rather quickly :)',
  resume: '', // if no resume, the button will not show up
};

const pdInfo = `
  My time in Pipedrive, an Estonian unicorn, has been quite eventful - I started as a Backend Engineer with an amazing team in Tartu while still completing my master's degree, but later moved to Tallinn.
  Here I have been part of many cross-functional teams, got my first chance to try out being an Engineering Team Lead, and even do Product research.
  My main product area in Pipedrive has been business analytics, which required me to learn managing Elasticsearch clusters and work regularly with large data migrations. Most recently I have been working on integrating LLMs into Pipedrive product to help with feature onboarding.
`

const imsInfo = `
  At the final year of my Bachelor's I started work in the Intelligent Materials and Systems lab and researched feasibility of creating a remote robotics laboratory, something that had become rather relevant with onset of COVID-19. During my master's I continued its development, made it the subject of
`

const tartuUniversityInfo = `
  Starting studies in the Science & Technology BSc program. First exposure to programming (with Python) at a Bioinformatics course - I find it intruiging and it leads me to choose the Robotics specialization, whereupon I become familiar with image processing, and control algorithms.
`

// JOURNEY DATA
// Replace the placeholder text and years below when the final career copy is ready.
export const timelineData = [
  {
    id: nanoid(),
    year: '2023',
    organization: 'Pipedrive',
    content: [
      {
        type: 'text',
        value: pdInfo,
      },
    ],
    logo: 'pipedrive',
    logoLabel: 'Pipedrive',
  },
  {
    id: nanoid(),
    year: '2021',
    organization: 'IMS Lab at Tartu University Institute of Technology (TUIT)',
    content: [
      {
        type: 'text',
        value: imsInfo,
        link: {
          label: 'my master’s thesis',
          url: '/thesis.pdf',
        },
        suffix: ', and wrote two research papers about it:',
      },
      {
        type: 'links',
        // Add papers here, for example:
        items: [
          {
            label: 'Open Remote Web Lab for Learning Robotics and ROS With Physical and Simulated Robots in an Authentic Developer Environment (2024)', url: 'https://ieeexplore.ieee.org/document/10480223/'
          },
          {
            label: 'Open-Source Web Lab for Remote and On-Site Robotics Practice in a Realistic Zero-Setup ROS 2 Development Environment (2025)', url: 'https://ieeexplore.ieee.org/document/11229930'
          },
        ],
      },
      {
        type: 'text',
        value: 'The results were presented in multiple conferences (ROSCon, ICRA).',
      },
    ],
    logo: 'ims',
    logoLabel: 'IMS',
  },
  {
    id: nanoid(),
    year: '2018',
    organization: 'University of Tartu',
    content: [
      {
        type: 'text',
        value: tartuUniversityInfo,
      },
    ],
    logo: 'tartu',
    logoLabel: 'Tartu University S&T',
  }
];

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'smart-solution.png',
    galleryImgs: [
      {
        video: true,
        name: 'dash3.png',
        url: 'https://www.youtube.com/embed/2Eh_obGLyck?si=iDIM1a8eMvRuPIkn', // Robot moving
        order: 1
        // url: 'https://www.youtube.com/embed/q86g1aop6a8'
      },
      {
        video: false,
        name: 'landing.png',
        order: 2
      },
      {
        video: false,
        name: 'admin-panel.png',
        order: 4
      },
      {
        video: false,
        name: 'overview.png',
        order: 5
      },
      {
        video: true,
        name: 'user-panel.png',
        url: 'https://www.youtube.com/embed/A3_WH9BOUK0', // Edgelord
        order: 3
        // url: 'https://www.youtube.com/embed/q86g1aop6a8'
      },

    ],
    title: 'Remote robotics (REMROB)',
    info: 'A remote robotics lab for students who wish to learn ROS (Robot Operating System) without spending extensive time setting up a Linux and Robotics software development environment. The users essentially got a Linux Virtual Machine connected to a mobile robot in their browser window.',
    info2: 'The project involved designing and building a web application and maintaining it on a self-hosted server.',
    url: 'https://remrob.ut.ee',
    repo: 'https://github.com/unitartu-remrob/remrob-server', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    galleryImgs: [
      {
        video: true,
        name: "smart-solution.png",
        url: 'https://www.youtube.com/embed/04kpMEyUzi4',
        order: 1
      },
      {
        video: false,
        name: 'breadboard.png',
        order: 3
      },
    ],
    title: 'Breadboard DJ',
    info: 'A custom made ESP32 development board with potentiometer plugs that allow to change the volume of different music samples on a public website. Anyone connected can listen in to the DJ controlling the board and change the samples if the active ones are not to their liking 🎵',
    info2: '',
    url: 'https://adwinthief.com',
    repo: 'https://github.com/Tsapu/smart-solution', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    galleryImgs: [
      {
        video: false,
        name: "react-store/store_1.png",
        order: 1
      },
      {
        video: false,
        name: "react-store/store_2.png",
        order: 2
      },
      {
        video: false,
        name: "react-store/store_3.png",
        order: 3
      },
      {
        video: false,
        name: "react-store/store_4.png",
        order: 4
      },
      {
        video: false,
        name: "react-store/store_5.png",
        order: 5
      },
    ],
    title: 'Minimalist e-commerce site',
    info: 'A simple online storefront I built to learn React and find out how state management and routing function in a CSR app.',
    info2: '',
    url: 'https://react-simple-storefront.herokuapp.com',
    repo: 'https://github.com/Tsapu/minimalist-react-store', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    galleryImgs: [
      {
        video: false,
        name: "honeybear/aktivitates.jpg",
        order: 5
      },
      {
        video: false,
        name: 'honeybear/dzejoli.jpg',
        order: 4
      },
      {
        video: false,
        name: 'honeybear/galerija.jpg',
        order: 1
      },
      {
        video: false,
        name: 'honeybear/pasakas.jpg',
        order: 6
      },
      {
        video: false,
        name: 'honeybear/kontakti.jpg',
        order: 7
      },
      {
        video: false,
        name: 'honeybear/sakumlapa_1.jpg',
        order: 3
      },
      {
        video: false,
        name: 'honeybear/sakumlapa_2.jpg',
        order: 2
      },
    ],
    title: 'Honey bear',
    info: 'A website with a custom Wordpress theme for a Latvian children\'s book with cute poems.',
    info2: '',
    url: 'http://sbtest.42web.io',
    repo: 'https://github.com/Tsapu/SB', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'davis.kruumins@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Tsapu',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/d%C4%81vis-kr%C5%ABmi%C5%86%C5%A1-583192246/',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
